import React from "react"
import "react-phone-number-input/style.css"
import PhoneInput from "react-phone-number-input"
import "./style.scss"

const CustomNumber = ({ value, onChange, getCountryCode }) => {
  return (
    <div className="custom-input">
      <PhoneInput
        international={true}
        defaultCountry="US"
        placeholder="Enter phone number"
        value={value}
        onChange={onChange}
        onCountryChange={getCountryCode}
      />
    </div>
  )
}

export default CustomNumber
